import React from 'react';
import { useScript, useScripts } from '../hooks/useScript';
import { ScriptLoadStrategy, ScriptProps } from '../types/types';

type Props = ScriptProps & {
    strategy?: ScriptLoadStrategy;
    onLoad?: () => void;
    onReady?: () => void;
    onError?: (e: Error) => void;
};

const Script: React.FC<Props> = (props) => {
    useScript(props);
    return null;
};

type ScriptBundleProps = {
    scripts: ScriptProps[];
    strategy?: ScriptLoadStrategy;
    onReady?: () => void;
    onError?: (e: Error) => void;
};

const Scripts: React.FC<ScriptBundleProps> = (props) => {
    useScripts(props);
    return null;
};

export { Script, Scripts };
